// @flow

import { combineReducers } from 'redux'
import {
  activeMunicipality,
  valuesByMunicipality
} from '../components/map/reducer'
import { requestStatus } from '../components/loadingIndicator/reducer'
import type { RequestStatus } from '../components/loadingIndicator/reducer'
import { categorySelection } from '../components/selector/reducer'
import type { CategorySelectionState } from '../components/selector/reducer'
import { popupReducer as popup } from 'components/popup/reducer'
import type { InteractionCapabilities } from '../components/interactionCapabilities/reducer'
import interactionCapabilities from 'components/interactionCapabilities/reducer'
import type { PopupState } from 'components/popup/reducer'
import type { Municipality } from 'components/../sources/types'
import type { D3Map } from 'components/choroplethMap/choroplethMapComponent'
import { extents, overallExtents, type Extents } from 'components/scale/reducer'
import { brackets } from 'components/selector/reducer'
import { filter, type FilterType } from 'components/municipalitySearch/reducer'

export type AppState = {
  +valuesByMunicipality: D3Map<Municipality>,
  +activeMunicipality: number,
  +requestStatus: RequestStatus,
  +categorySelection: CategorySelectionState,
  +popup: PopupState,
  +interactionCapabilities: InteractionCapabilities,
  +extents: Extents,
  +overallExtents: Extents,
  +brackets: Array<number>,
  +filter: FilterType
}

export const rentPriceMapReducers: (
  state: AppState,
  action: any
) => AppState = combineReducers({
  valuesByMunicipality,
  activeMunicipality,
  requestStatus,
  categorySelection,
  popup,
  interactionCapabilities,
  extents,
  overallExtents,
  brackets,
  filter
})



// WEBPACK FOOTER //
// ./src/stores/index.js